/**
 * The various major z-index layers, adjust with caution and leave space between to add to later.
 */
export const Layers = {
    BlurContentOverlay: 5,
    Header: 10,
    Modal: 1000,
};
